import React from 'react';
import PropTypes from 'prop-types';

const MosaicWall = ({
  title,
  children,
  childrenContainerClassName,
  placeholder,
}) => (
  <div
    className={`container ${children && children.length > 0 ? 'mb-3' : 'mb-0'}`}
  >
    {title && (
      <div className="hr-divider">
        <h3 className="hr-divider-content hr-divider-heading">{title}</h3>
      </div>
    )}
    <div
      placeholder={placeholder}
      className={`mosaic-wall ${childrenContainerClassName}`}
    >
      {children}
    </div>
  </div>
);

MosaicWall.propTypes = {
  title: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node),
  childrenContainerClassName: PropTypes.string,
  placeholder: PropTypes.string,
};

MosaicWall.defaultProps = {
  childrenContainerClassName: 'row',
};

export default MosaicWall;
